import valuer_api from "../../api/valuer";
import {useEffect, useState} from "react";


const ValuerAmendRadioButton = (props) => {

    const label = props.label;
    const value = props.value;
    const inline = props.inline;
    const updateFunction = props.updateFunction

    // Saving
    const section = props.section;
    const summaryId = props.summaryId;

    // Saving Tracker
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    const [textValue, setTextValue] = useState('');
    const descriptionDefault = props.descriptionDefault ? props.descriptionDefault : '';
    const descriptionMinHeight = props.descriptionMinHeight ? props.descriptionMinHeight : '48px';
    const optionRequiresDescription = props.optionRequiresDescription ? props.optionRequiresDescription : false
    const descriptionIdentifier = props.descriptionIdentifier ? props.descriptionIdentifier : ""

    const normalize = (v) => {
        try {
            if (typeof v === 'string') v = JSON.parse(v);
        } catch {}
        return (v && typeof v === 'object') ? v.value : v;
    };
    const selected = normalize(props.selected) === normalize(value);




    useEffect(() => {
        if (props.textValue === undefined) return
        setTextValue(props.textValue);
    }, [props.textValue]);

    const UpdateValue = () => {
        // Update Text option of radio
        let updateTime = Date.now()
        AddToQueue(section, descriptionIdentifier, updateTime)
        let body = { "value": textValue}
        UpdateParentValue(descriptionIdentifier, textValue)
        setTextValue('')
        let response = valuer_api.ValuerAmendPut(summaryId, section, descriptionIdentifier, body);
        response.then(
            response => {
                RemoveFromQueue(section, descriptionIdentifier, updateTime)
            }
        ).catch((err) => {
            AddToErroredSaves(section, descriptionIdentifier, updateTime)
            setErrorTitle("Failed to Save")
            setErrorMessage("The request to save a field has failed")
        })
    }

    const ClickOff = () => {
        // Check for required fields and then submit change for text change
        if (!summaryId || !section || !descriptionIdentifier) return
        UpdateValue()
    }

    const ClickRadio = () => {
        // When radio button is clicked, if it is already selected
        if (selected) {
            // Reset Radio
            updateFunction(null, null);
            // Update Text option of radio to be blank if it requires a description
            if (optionRequiresDescription) {
                let _blank= ""
                let updateTime = Date.now()
                AddToQueue(section, descriptionIdentifier, updateTime)
                let body = { "value": _blank}
                setTextValue(_blank)
                UpdateParentValue(descriptionIdentifier, _blank)
                let response = valuer_api.ValuerAmendPut(summaryId, section, descriptionIdentifier, body);
                response.then(
                    response => {
                        RemoveFromQueue(section, descriptionIdentifier, updateTime)
                    }
                ).catch((err) => {
                    AddToErroredSaves(section, descriptionIdentifier, updateTime)
                    setErrorTitle("Failed to Save")
                    setErrorMessage("The request to save a field has failed")
                })
            }


        }
        else {
            // Update Radio
            updateFunction(value, label)
            // Update Text option of radio to be blank if it requires a description
            if (optionRequiresDescription) {
                let updateTime = Date.now()
                AddToQueue(section, descriptionIdentifier, updateTime)
                let body = {"value": descriptionDefault}
                UpdateParentValue(descriptionIdentifier, descriptionDefault)
                setTextValue(descriptionDefault)
                let response = valuer_api.ValuerAmendPut(summaryId, section, descriptionIdentifier, body);
                response.then(
                    response => {
                        RemoveFromQueue(section, descriptionIdentifier, updateTime)
                    }
                ).catch((err) => {
                    AddToErroredSaves(section, descriptionIdentifier, updateTime)
                    setErrorTitle("Failed to Save")
                    setErrorMessage("The request to save a field has failed")
                })
            }
        }
    }

    return (
        <>
            <div className={"valuer-amend-radio-button-container" + (inline ? ' inline' : '')}
                 onClick={() => ClickRadio()}>
                <div className="valuer-amend-radio-button-circle">
                    {selected && selected
                        ? <div className="valuer-amend-radio-button-circle-inner"/>
                        : null
                    }
                </div>
                <div className="valuer-amend-radio-button-text">
                    {label && label}
                </div>
            </div>
            {optionRequiresDescription && descriptionIdentifier && !inline && selected
                ?
                <div className="valuer-amend-radio-button-additional-description-container" style={{minHeight: descriptionMinHeight}}>
                    <textarea value={textValue} className="valuer-amend-radio-description-field" defaultValue={descriptionDefault}
                              onChange={(ev) => setTextValue(ev.target.value)}
                              onBlur={() => ClickOff()} style={{minHeight: descriptionMinHeight}}/>
                </div>
                : null
            }


        </>

    )
}

export default ValuerAmendRadioButton;